import api from "./api";

// Schlägt Ort/Bundesland/Land zu einer deutschen PLZ nach (eingebettete DB im Backend).
// Gibt null zurück, wenn die PLZ nicht 5-stellig ist oder nicht gefunden wird.
export async function lookupPlz(zip) {
  const z = String(zip || "").trim();
  if (!/^\d{5}$/.test(z)) return null;
  try {
    const { data } = await api.get(`/geo/plz/${z}`);
    return data && data.found ? data : null;
  } catch (_e) {
    return null;
  }
}
